import { render } from "./ThumbnailDropzone.vue?vue&type=template&id=d1a9b878&scoped=true"
import script from "./ThumbnailDropzone.vue?vue&type=script&lang=js"
export * from "./ThumbnailDropzone.vue?vue&type=script&lang=js"

import "./ThumbnailDropzone.vue?vue&type=style&index=0&id=d1a9b878&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d1a9b878"

export default script